// Tracking utility functions for Michigan Aviation
// Supports META Pixel, GTM, and custom analytics

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

export type TrackingEvent = 
  | 'book_appointment_click'
  | 'flightbridge_click'
  | 'fuel_alert_signup'
  | 'phone_click'
  | 'contact_form_submit'
  | 'page_view'

export function trackEvent(eventName: TrackingEvent, params?: Record<string, unknown>) {
  // Meta Pixel tracking
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params)
  }

  // GTM / dataLayer tracking
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...params,
    })
  }

  // Console log for development
  if (process.env.NODE_ENV === 'development') {
    console.log('[v0] Track Event:', eventName, params)
  }
}

export function trackPhoneClick(phoneNumber: string) {
  trackEvent('phone_click', { phone_number: phoneNumber })
}

export function trackBookAppointment(source: string) {
  trackEvent('book_appointment_click', { source })
}

export function trackFlightBridge() {
  trackEvent('flightbridge_click')
}

export function trackFuelAlertSignup(email: string) {
  trackEvent('fuel_alert_signup', { email_domain: email.split('@')[1] })
}

export function trackContactFormSubmit(formData: Record<string, unknown>) {
  trackEvent('contact_form_submit', formData)
}

// UTM parameter handling
export function getUTMParams(): Record<string, string> {
  if (typeof window === 'undefined') return {}
  
  const params = new URLSearchParams(window.location.search)
  const utmParams: Record<string, string> = {}
  
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
  utmKeys.forEach(key => {
    const value = params.get(key)
    if (value) utmParams[key] = value
  })
  
  return utmParams
}
